module.exports = __webpack_public_path__ + "static/media/icon_placeholder_pipeline-configure.b8d3db44.svg";